<section *ngIf="showEligibilityQuestions()">
    <div class="bl-margin-bottom--4 bl-overflow-wrap--break-word">
        <div class="bl-display--flex" *ngFor="let ans of selectedques" [attr.data-automation-id]="'question-'+arrayIndexofSelectedQuestion">
            <div class="bl-margin-y--4 bl-col-6 bl-padding-x--0 bl-overflow-wrap--break-word">
                {{ans.questionText}}
            </div>
            <div class="bl-col-5 bl-margin-y--4 bl-padding-left--24 bl-overflow-wrap--break-word">
                    {{ans.value}}
            </div>
        </div>
    </div>
</section>